import styled from 'styled-components';

export const InfoBox = styled.div`
  margin-bottom: var(--spacer-M);
  padding: 12px;
  background-color: #f0f8ff;
  border-left: 4px solid #0066cc;
  border-radius: 4px;

  small {
    color: #555;
  }
`;
